import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({ icon: Icon = Inbox, title, description, action }) => (
    <div className="card p-10 text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-primary-50 text-primary-700 flex items-center justify-center">
            <Icon className="w-6 h-6" />
        </div>
        <h3 className="mt-3 text-sm font-semibold text-neutral-900">{title}</h3>
        {description && <p className="mt-1 text-sm text-neutral-500 max-w-md mx-auto">{description}</p>}
        {action && <div className="mt-4">{action}</div>}
    </div>
);

export default EmptyState;
